import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import HoverImage from '../HoverImage';
import fbWhiteIcon from '../../../assets/img/icons/fb-hover.svg';
import fbBlueIcon from '../../../assets/img/icons/fb-active.svg';
import twitterWhiteIcon from '../../../assets/img/icons/twitter-white-icon.svg';
import twitterBlueIcon from '../../../assets/img/icons/twitter-blue-icon.svg';

function ShareAuctionBox({
  target,
  placement = 'bottom',
  shareUrl,
  uncontrolledTooltipClassName = '',
}) {
  return (
    <UncontrolledTooltip
      placement={placement}
      target={target}
      trigger="click"
      className={`action-btn__tooltip ${uncontrolledTooltipClassName}`}
    >
      <div className="action-btn__tooltip-content">
        <div className="tooltip-content__item">
          <FacebookShareButton url={shareUrl}>
            <HoverImage
              defaultSrc={fbWhiteIcon}
              hoverSrc={fbBlueIcon}
              alt="Facebook icon"
              className="hover-button"
            />
          </FacebookShareButton>
          <span className="tooltip-content__item-title">Facebook</span>
        </div>
        <div className="tooltip-content__item">
          <TwitterShareButton url={shareUrl}>
            <HoverImage
              defaultSrc={twitterWhiteIcon}
              hoverSrc={twitterBlueIcon}
              alt="Twitter icon"
              className="hover-button"
            />
          </TwitterShareButton>
          <span className="tooltip-content__item-title">Twitter</span>
        </div>
      </div>
    </UncontrolledTooltip>
  );
}

export default ShareAuctionBox;
